import axios from "../axios/axios";
import { appSetSendingRequest } from "../store/actions/appAction";
import { apiSetAlert } from "./appApi";
import { errorDispatcher } from "../helpers";

export const apiUploadMedia = async (media, token, callBack,dispatch ) => {
  dispatch(appSetSendingRequest(true));
  await axios
    .post(`/media/upload`, media, {
      headers: { Authorization: `Bearer ${token}`, "Content-Type": "multipart/form-data" },
    })
    .then((response) => {
      dispatch(apiSetAlert(response.data.message, "success"));
      callBack(response.data.data[0].url);
    })
    .catch((error) => {
      errorDispatcher(error, dispatch);
    });
};
export const apiDeleteMedia = (data, token, callBack) => (dispatch, getState) => {
  const url = new URL(data.url).pathname;
  dispatch(appSetSendingRequest(true));
  axios
    .delete(`media`, {
      headers: { Authorization: `Bearer ${token}` },
      data: { url },
    })
    .then((response) => {
      dispatch(apiSetAlert(response.data.message, "success"));
      callBack("delete");
    })
    .catch((error) => {
      callBack("delete");
      errorDispatcher(error, dispatch);
    });
};
